import React from 'react';
import { useAdvisorForm } from './hooks/useAdvisorForm';
import useEscapeKey from '../hooks/useEscapeKey';

const FormField = ({ id, label, type, value, onChange, placeholder }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-gray-300 mb-2">{label}</label>
    <input type={type} id={id} name={id} value={value} onChange={onChange} required
      className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-hidden focus:ring-2 focus:ring-green-500"
      placeholder={placeholder} />
  </div>
);

const AddAdvisorModal = ({ isOpen, onClose, onSuccess }) => {
  const { formData, loading, error, handleSubmit, handleChange } = useAdvisorForm(onSuccess, onClose);

  useEscapeKey(onClose, isOpen);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-xl max-w-md w-full p-6 border border-gray-700">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-white">Add Trusted Professional</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-500/10 border border-red-500 rounded-lg text-red-400 text-sm">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <FormField id="name" label="Full Name *" type="text" value={formData.name} onChange={handleChange} placeholder="John Doe" />
          <FormField id="email" label="Email Address *" type="email" value={formData.email} onChange={handleChange} placeholder="professional@firm.com" />
          <FormField id="company" label="Firm / Company *" type="text" value={formData.company} onChange={handleChange} placeholder="ABC Wealth Partners" />

          <div className="bg-blue-500/10 border border-blue-500/50 rounded-lg p-3 text-sm text-blue-400">
            <p className="font-medium mb-1">Portal Link Will Be Sent</p>
            <p className="text-xs text-blue-300">They will receive an email with a private portal link that stays active for a year, and auto-renews for another year each time they use it. Up to 3 client introductions per week. They will pick how they relate to each introducee on the form itself.</p>
          </div>

          <div className="flex space-x-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-medium transition">Cancel</button>
            <button type="submit" disabled={loading} data-testid="add-trusted-professional-submit" className="flex-1 px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg font-medium transition disabled:opacity-50 disabled:cursor-not-allowed">
              {loading ? 'Creating...' : 'Create Trusted Professional'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAdvisorModal;
